import type { DemandeRendezVousInitieeRepresentation, RendezVousRepresentation } from '~/types/typesRendezVous';

export const useRendezVousStore = defineStore('rendez-vous', () => {
    const vehiculeStore = useVehiculeStore();
    const authentificationStore = useAuthentificationStore();
    const loaderStore = useLoaderStore();
    const toasterStore = useToasterStore();

    const listeRendezVous = ref<RendezVousRepresentation[] | null>();

    const setListeRendezVous = (data?: RendezVousRepresentation[]) => {
        listeRendezVous.value = data;
    }

    const getListeRendezVous = computed(() => listeRendezVous.value);

    const initRendezVous = async (
        idFournisseur: string,
        idFournisseurReseau: string | undefined,
        prestations: PrestationsVehiculeCopilotEntry[],
        kilometrage: number,
        isNorauto: boolean,
    ): Promise<string | null> => {
        loaderStore.showLoader();
        try {
            const { data } = await useMyFetch<DemandeRendezVousInitieeRepresentation>(
                '/copilot/vehicules/' + vehiculeStore.getIdActif() + '/rendez-vous',
                {
                    method: 'POST',
                    body: {
                        idFournisseur: idFournisseur,
                        idFournisseurReseau: idFournisseurReseau,
                        numeroDossier: vehiculeStore.getNumeroDossier(),
                        prestations: prestations.map(p => p.prestationCopilot),
                        dateDemande: new Date(Date.now()),
                        kilometrage: kilometrage,
                    },
                    headers: {
                        'Content-Type': 'application/json'
                    },
                },
            );
            if (data.value?.redirectUrl) {
                return data.value.redirectUrl;
            }
            // On refresh la liste des rdv pour s'assurer que notre cache est à jour
            await recupererDemandesRendezVous();
            return null;
        } catch (error) {
            toasterStore.afficherLeToaster('error', 'messageErreur.erreurCreationRendezVous');
            return null;
        } finally {
            loaderStore.hideLoader();
        }
    }


    const recupererDemandesRendezVous = async () => {
        loaderStore.showLoader();
        try {
            const { data, error } = await useMyFetch<RendezVousRepresentation[]>('/copilot/vehicules/' + vehiculeStore.getIdActif() + '/rendez-vous', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            });

            if (data.value) {
                setListeRendezVous(data.value);
            }

        } catch (error) {
            toasterStore.afficherLeToaster('error', 'messageErreur.erreurRecupRendezVous');
        } finally {
            loaderStore.hideLoader();
        }
    }

    const recupererDemandesRendezVousEnCours = async (): Promise<RendezVousRepresentation[]> => {
        try {
            const { data } = await useMyFetch<RendezVousRepresentation[]>(
                '/copilot/vehicules/' + vehiculeStore.getIdActif() + '/rendez-vous/en-cours',
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                },
            );
            return data.value || [];
        } catch (error) {
            toasterStore.afficherLeToaster('error', 'messageErreur.erreurRecupRendezVous');
            return [];
        }
    }

    return {
        initRendezVous,
        recupererDemandesRendezVous,
        recupererDemandesRendezVousEnCours,
        getListeRendezVous
    }
});